import React from 'react';
// eslint-disable-next-line react/no-deprecated
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { fromJS } from 'immutable';
import '@nosferatu500/react-sortable-tree/style.css';
/*
 * Append styles for client build.
 * It will be built by Webpack.
 * It is placed here because:
 *  - node.js can not require stylesheets
 *  - server does not need style at all
 * Global styles must be imported before any component (RootRouter), so component CSS modules
 * come later in the cascade and win over global rules of equal specificity.
 */
import './styles/style.css';
import 'react-input-range/lib/css/index.css';
/**
 * Append react-datepicker styles.
 */
import 'react-datepicker/dist/react-datepicker.css';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-fresh.css';

import initAppSpy from './client/getAppState';
import configureStore from './store/configureStore';
import RootRouter from './routing/RootRouter';

/*
 * Activate bootstrap bindings (dropdowns, modals and so) on client.
 * It is needed only on client side.
 */
import './client/bootstrap_bind';
import './sentry';

if (typeof window.setImmediate === 'undefined') {
  window.setImmediate = (fn, ...args) => setTimeout(fn, 0, ...args);
}

const reduxState = {};

if (window.__REDUX_STATE__) {
  try {
    const plain = JSON.parse(decodeURIComponent(window.__REDUX_STATE__));

    Object.keys(plain).forEach(key => {
      reduxState[key] = fromJS(plain[key]);
    });
  } catch (error) {
    throw new Error('Error in ReduxState parse. Use empty state.', error);
  }
}

const store = configureStore(reduxState);

initAppSpy(store);

// The function for rendering React components in the DOM has been changed due to an error
// https://saritasa.atlassian.net/browse/HARV-1003
render(
  <Provider store={store}>
    <RootRouter />
  </Provider>,
  document.getElementById('root'),
);
